export default {
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  IdentityPoolId: import.meta.env.VITE_COGNITO_POOL_ID || 'us-east-1_4o5z6cXvf',
  UserPoolId: '',
  ClientId:
    import.meta.env.VITE_COGNITO_CLIENT_ID || '4855fcbs3m8gnqucqfdhsqpffl'
}

export const menu = [
  {
    name: 'menu.searchModule',
    icon: 'SearchLgIcon',
    openSearch: true
  },
  {
    name: 'menu.settings',
    icon: 'Tool02Icon',
    children: [
      {
        name: 'menu.countrySettings',
        idMenu: '1',
        children: [
          {
            name: 'menu.countries',
            route: '/countries',
            permission: 'country:list'
          },
          {
            name: 'menu.states',
            route: '/states',
            permission: 'state:list'
          },
          {
            name: 'menu.cities',
            route: '/cities',
            permission: 'city:list'
          },
          {
            name: 'menu.listHolidays',
            route: '/list-holidays',
            permission: 'holiday_group:list'
          },
          {
            name: 'menu.countryParameters',
            route: '/country-parameters',
            permission: 'country_parameter:list'
          },
          {
            name: 'menu.contractTypes',
            route: '/contract-types',
            permission: 'contract_type:list'
          },
          {
            name: 'menu.currencies',
            route: '/currencies',
            permission: 'currency:list'
          },
          {
            name: 'menu.educationLevels',
            route: '/education-levels',
            permission: 'education_level:list'
          },
          {
            name: 'menu.identificationTypes',
            route: '/identification-types',
            permission: 'identification_type:list'
          },
          {
            name: 'menu.caps',
            route: '/caps',
            permission: 'cap:list'
          },
          {
            name: 'menu.fiscalRules',
            route: '/fiscal-rules',
            permission: 'fiscal_rules:list'
          },
          {
            name: 'menu.governmentNewsConfig',
            route: '/government-news/configure',
            permission: 'government-news:configure'
          }
        ]
      },
      {
        name: 'menu.reasons',
        idMenu: '1',
        children: [
          {
            name: 'menu.joiningReasons',
            route: '/joining-reasons',
            permission: 'joinning_reason:list'
          },
          {
            name: 'menu.leaveReasons',
            route: '/leave-reasons',
            permission: 'leave_reason:list'
          },
          {
            name: 'menu.increaseReasons',
            route: '/increase-reasons',
            permission: 'increase_reason:list'
          }
        ]
      },
      {
        name: 'menu.implementation',
        idMenu: '1',
        children: [
          {
            name: 'menu.companies',
            route: '/companies',
            permission: 'company:list'
          },
          {
            name: 'menu.payrolls',
            route: '/payrolls',
            permission: 'payroll:list'
          },
          {
            name: 'menu.calendars',
            route: '/calendars',
            permission: 'calendar:list'
          },
          {
            name: 'menu.positions',
            route: '/positions',
            permission: 'position:list'
          },
          {
            name: 'menu.journeys',
            route: '/journeys',
            permission: 'journey:list'
          },
          {
            name: 'menu.directions',
            route: '/directions',
            permission: 'direction:list'
          },
          {
            name: 'menu.managements',
            route: '/managements',
            permission: 'management:list'
          },
          {
            name: 'menu.locations',
            route: '/locations',
            permission: 'sucursal:list'
          },
          {
            name: 'menu.turns',
            route: '/turns',
            permission: 'turn:list'
          },
          {
            name: 'menu.costCenters',
            route: '/cost-centers',
            permission: 'cost_center:list'
          },
          {
            name: 'menu.departments',
            route: '/departments',
            permission: 'department:list'
          },
          {
            name: 'menu.entities',
            route: '/entities',
            permission: 'entity:list'
          },
          {
            name: 'menu.banks',
            route: '/banks',
            permission: 'bank:list'
          }
        ]
      },
      {
        name: 'menu.concepts',
        idMenu: '1',
        children: [
          {
            name: 'menu.processes',
            route: '/processes',
            permission: 'process:list'
          },
          {
            name: 'menu.masterConcepts',
            route: '/master-concepts',
            permission: 'master_concept:list'
          },
          {
            name: 'menu.masterConceptGroups',
            route: '/master-concept-groups',
            permission: 'concept_group:list'
          },
          {
            name: 'menu.payrollCopyRequests',
            route: '/payroll-copy-requests',
            permission: 'payroll_copy_request:list'
          },
          {
            name: 'menu.payrollConcepts',
            route: '/payroll-concepts',
            permission: 'concept:list'
          },
          {
            name: 'menu.ledgerAccounts',
            route: '/ledger-accounts',
            permission: 'ledger_account:list'
          },
          {
            name: 'menu.validations',
            route: '/validations',
            permission: 'validation:list'
          },
          {
            name: 'menu.savedFormulas',
            route: '/saved-formulas',
            permission: 'saved_formula:list'
          },
          {
            name: 'menu.benefits',
            route: '/benefits',
            permission: 'benefit:list'
          },
          {
            name: 'menu.calculatePhases',
            route: '/calculate-phases',
            permission: 'phase:list'
          }
        ]
      }
    ]
  },
  {
    name: 'menu.employees',
    icon: 'Users01Icon',
    children: [
      {
        name: 'menu.employeeTypes',
        route: '/employee-types',
        permission: 'employee_type:list'
      },
      {
        name: 'menu.employees',
        route: '/employees',
        permission: 'employee:list'
      },
      {
        name: 'menu.increaseSalaryRequests',
        route: '/increase-salary-requests',
        permission: 'increase_salary_request:list'
      },
      {
        name: 'menu.governmentNews',
        route: '/government-news',
        permission: 'government-news:list'
      },
      {
        name: 'menu.transferRequests',
        route: '/transfer-requests',
        permission: 'transfer:list'
      }
    ]
  },
  {
    name: 'menu.processes',
    icon: 'CalculatorIcon',
    children: [
      {
        name: 'menu.payrolls',
        idMenu: '3',
        children: [
          {
            name: 'menu.exchangeRates',
            route: '/exchange-rates',
            permission: 'exchange_rate:list'
          },
          {
            name: 'menu.incidents',
            route: '/incidents',
            permission: 'incident:list'
          },
          {
            name: 'menu.recurringIncidents',
            route: '/recurring-incidents',
            permission: 'recurrent_incident:list'
          },
          {
            name: 'menu.incidentsDeletionRequest',
            route: '/incidents-deletion-request',
            permission: 'delete_incident_request:list'
          },
          {
            name: 'menu.recurringIncidentsDeletionRequest',
            route: '/recurring-incidents-deletion-request',
            permission: 'recurrent_incident:delete'
          },
          {
            name: 'menu.pendingProcess',
            route: '/pending-process',
            permission: 'calc_controller:execute'
          },
          {
            name: 'menu.pendingProcesses',
            route: '/pending-processes',
            permission: 'pending_process:list'
          },
          {
            name: 'menu.processedPayrolls',
            route: '/processed-payrolls',
            permission: 'payroll_processed:list'
          },
          {
            name: 'menu.reversePayrolls',
            route: '/reverse-payrolls',
            permission: 'reverse-request:list'
          }
        ]
      },
      {
        name: 'menu.vacations',
        idMenu: '3',
        children: [
          {
            name: 'menu.vacationPolicies',
            route: '/vacation-policies',
            permission: 'vacation_policie:list'
          },
          {
            name: 'menu.vacationRequests',
            route: '/vacation-requests',
            permission: 'vacation_request:list'
          },
          {
            name: 'menu.vacationBalances',
            route: '/vacation-balances',
            permission: 'vacation_balance:list'
          },
          {
            name: 'menu.vacationAccumulationRequests',
            route: '/vacation-accumulation-requests',
            permission: 'vacation_balance:list'
          }
        ]
      },
      {
        name: 'menu.licenses',
        idMenu: '3',
        children: [
          {
            name: 'menu.licenseTypes',
            route: '/license-types',
            permission: 'license_type:list'
          },
          {
            name: 'menu.licensesAndPermits',
            route: '/licenses',
            permission: 'license:list'
          }
        ]
      },
      {
        name: 'menu.loans',
        route: '/loans',
        permission: 'loan:list'
      },
      {
        name: 'menu.liquidationRequests',
        route: '/liquidation-requests',
        permission: 'liquidation_request:list'
      }
    ]
  },
  {
    name: 'menu.reports',
    icon: 'File07Icon',
    children: [
      {
        name: 'menu.reports',
        route: '/reports',
        permission: 'report:list'
      },
      {
        name: 'menu.internalReports',
        route: '/internal-reports',
        permission: 'report-internal:list'
      },
      {
        name: 'menu.payrollReceipt',
        route: '/payroll-receipt',
        permission: 'report:list'
      },
      {
        name: 'menu.configureReports',
        route: '/configure-reports',
        permission: 'configure-report:create'
      },
      {
        name: 'menu.certifiedLetters',
        route: '/certified-letters',
        permission: 'reports_request:create'
      }
    ]
  },
  {
    name: 'menu.administration',
    icon: 'Shield02Icon',
    children: [
      {
        name: 'menu.users',
        route: '/users',
        permission: 'user:list'
      },
      {
        name: 'menu.workspace',
        route: '/workspace',
        permission: 'user:set_workspace'
      },
      {
        name: 'menu.roles',
        route: '/roles',
        permission: 'role:list'
      },
      {
        name: 'menu.importRequests',
        route: '/import-requests',
        permission: 'import:list'
      },
      {
        name: 'menu.receiptTemplates',
        route: '/receipt-templates',
        permission: 'receipt_template:list'
      },
      {
        name: 'menu.integrations',
        idMenu: '5',
        children: [
          {
            name: 'menu.apiKeys',
            route: '/api-keys-management',
            permission: 'apikeys:list'
          },
          {
            name: 'menu.subscriptions',
            route: '/subscriptions-management',
            permission: 'trigger:list'
          }
        ]
      }
    ]
  }
]
